<template>
  <div class="questionnaire-paper">
    <div class="questionnaire-back"></div>
    <div class="questionnaire-main" v-if="dataDone">
      <questionnaire :form-data="formData" />
      <div class="back"><button class="back-button" @click="back">返回</button></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-paper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    .questionnaire-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @wenzhen;
      z-index: 1;
    }
    .questionnaire-main{
      position: relative;
      z-index: 10;
      padding: 4px 8px 0;
      .back{
        margin: 24px 0 12px;
        .back-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import questionnaire from '@/components/Common/questionnaire'
  export default {
    data() {
      return {
        dataDone: false,
        formData: {},
      }
    },
    components: {
      questionnaire
    },
    created() {
      // 获取问诊单数据
      this.$root.post('/getPatientAnswer', {
        id: this.$route.params.id
      }).then(data => {
        console.log("问诊单")
        console.log(data);
        this.dataDone = true;
        this.formData = data;
      })
    },
    methods: {
      back() {
        this.$router.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/questionnairePaper.vue